/* SARTE price-range slider interaction */
(function(){
  'use strict';
  function moneyLabel(value){
    var n = Number(value);
    if (!isFinite(n)) n = 0;
    try {
      return 'Rs. ' + n.toLocaleString(undefined,{minimumFractionDigits:n%1?2:0,maximumFractionDigits:2});
    } catch(e) {
      return 'Rs. ' + String(Math.round(n*100)/100);
    }
  }
  function sync(root, source){
    var minRange=root.querySelector('[data-sarte-price-min]');
    var maxRange=root.querySelector('[data-sarte-price-max]');
    var minInput=root.querySelector('[data-sarte-price-input="min"]');
    var maxInput=root.querySelector('[data-sarte-price-input="max"]');
    var minLabel=root.querySelector('[data-sarte-price-label-min]');
    var maxLabel=root.querySelector('[data-sarte-price-label-max]');
    var fill=root.querySelector('[data-sarte-price-fill]');
    if(!minRange||!maxRange||!minInput||!maxInput)return;
    var min=Math.min(Number(minRange.value),Number(maxRange.value));
    var max=Math.max(Number(minRange.value),Number(maxRange.value));
    var upper=Number(maxRange.max)||0;
    if(source==='min') minRange.value=String(Math.min(Number(minRange.value),max));
    if(source==='max') maxRange.value=String(Math.max(Number(maxRange.value),min));
    min=Math.min(Number(minRange.value),Number(maxRange.value));
    max=Math.max(Number(minRange.value),Number(maxRange.value));
    if(Number(minRange.value)>Number(maxRange.value)) minRange.value=String(max);
    if(Number(maxRange.value)<Number(minRange.value)) maxRange.value=String(min);
    minInput.value=min>0?String(min):'';
    maxInput.value=(max<upper && max>0)?String(max):'';
    if(minLabel)minLabel.textContent=moneyLabel(min);
    if(maxLabel)maxLabel.textContent=moneyLabel(max);
    if(fill){
      var left=upper?Math.max(0,Math.min(100,(min/upper)*100)):0;
      var right=upper?Math.max(0,Math.min(100,100-(max/upper)*100)):0;
      fill.style.left=left+'%';
      fill.style.right=right+'%';
      fill.style.width='auto';
    }
  }
  function bind(root){
    if(root.dataset.sartePriceReady==='1')return;
    root.dataset.sartePriceReady='1';
    var minRange=root.querySelector('[data-sarte-price-min]');
    var maxRange=root.querySelector('[data-sarte-price-max]');
    var minInput=root.querySelector('[data-sarte-price-input="min"]');
    var maxInput=root.querySelector('[data-sarte-price-input="max"]');
    if(!minRange||!maxRange||!minInput||!maxInput)return;
    ['input','change'].forEach(function(evt){
      minRange.addEventListener(evt,function(){ if(Number(minRange.value)>Number(maxRange.value))minRange.value=maxRange.value; sync(root,'min'); });
      maxRange.addEventListener(evt,function(){ if(Number(maxRange.value)<Number(minRange.value))maxRange.value=minRange.value; sync(root,'max'); });
      minInput.addEventListener(evt,function(){ var v=Number(minInput.value||0); var upper=Number(minRange.max)||0; v=Math.max(0,Math.min(v,upper)); if(v>Number(maxRange.value))v=Number(maxRange.value); minRange.value=v; sync(root,'min'); });
      maxInput.addEventListener(evt,function(){ var upper=Number(maxRange.max)||0; var v=Number(maxInput.value||upper); v=Math.max(0,Math.min(v,upper)); if(v<Number(minRange.value))v=Number(minRange.value); maxRange.value=v; sync(root,'max'); });
    });
    var form=root.closest('form');
    if(form)form.addEventListener('submit',function(){sync(root);});
    sync(root);
  }
  function ready(){
    document.querySelectorAll('[data-sarte-price-filter]').forEach(bind);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
  document.addEventListener('shopify:section:load',ready);
})();